<section>
  <div class="l-flex l-flex-wrap t-panel l-align-y">
    <!-- total dept-->
    <div *ngIf="selectedClinic" class="tot-dept">
      <span class="lbl">{{
        "translate.reports.remainingDept" | translate
      }}</span>
      &nbsp;&nbsp;
      <span class="sum l-num">{{ currentTotalDept | currency : "ILS" }}</span>
    </div>

    <!--documentId-->
    <input-wrap>
      <input
        class="t-input t-input-icon-search"
        type="number"
        [(ngModel)]="documentId"
        placeholder="{{ documentIdPlaceholder | translate }}"
        (keypress)="onKeyPress($event)"
      />
    </input-wrap>

    <!--clinic-->
    <input-wrap
      *ngIf="displayClinicFields"
      [loading]="clinicList && clinicList.loading"
    >
      <p-select
        [options]="clinicList"
        [(ngModel)]="selectedClinic"
        [filter]="true"
        [resetFilterOnHide]="true"
        filterBy="label,id"
        [placeholder]="'translate.general.clinic' | translate"
        [optionLabel]="'label'"
        [filterPlaceholder]="'translate.general.search' | translate"
        (onChange)="onFieldValueChanged($event)"
        [virtualScroll]="true"
        [virtualScrollItemSize]="30"
      ></p-select>
    </input-wrap>

    <!--from date-->
    <input-wrap>
      <p-datepicker
        dateFormat="dd/mm/yy"
        [(ngModel)]="fromDate"
        readonlyInput="readonlyInput"
        showButtonBar="true"
        placeholder="{{ 'translate.general.orderDateFrom' | translate }}"
        (onSelect)="search()"
        (onClearClick)="search()"
        (onTodayClick)="search()"
      ></p-datepicker>
    </input-wrap>

    <!--to date-->
    <input-wrap>
      <p-datepicker
        dateFormat="dd/mm/yy"
        [(ngModel)]="toDate"
        readonlyInput="readonlyInput"
        showButtonBar="true"
        placeholder="{{ 'translate.general.orderDateTo' | translate }}"
        (onSelect)="search()"
        (onClearClick)="search()"
        (onTodayClick)="search()"
      ></p-datepicker>
    </input-wrap>

    <div
      class="search-btn-container"
      *ngIf="!allowedSubmit()"
      [tooltip]="getValidationTooltip()"
    >
      <ng-container *ngTemplateOutlet="filterBtn"></ng-container>
    </div>
    <div class="search-btn-container" *ngIf="allowedSubmit()">
      <ng-container *ngTemplateOutlet="filterBtn"></ng-container>
    </div>
    <button class="t-button-outline c-c1" (click)="clearSearch()">
      {{ "translate.general.clearFilter" | translate }}
    </button>
  </div>

  <div
    class="reports-type-container l-flex t-panel l-align-y l-align-spaceBetween"
  >
    <div>
      <a
        *ngFor="let t of reportTypes"
        [class.selected]="isSelected(t)"
        (click)="selectReportType(t)"
        >{{ t.text | translate }}</a
      >
    </div>

    <!-- <div *ngIf="displayClinicFields && dispayedClinic" class="c1">
      {{ dispayedClinic.text }}
    </div> -->
  </div>
</section>

<ng-template #filterBtn>
  <button
    class="t-button t-button--flat"
    (click)="search()"
    [disabled]="!allowedSubmit()"
  >
    {{ "translate.general.search" | translate }}
  </button>
</ng-template>
